import { getBidUtils } from './src/bid-utils';
import { getDateUtils } from './src/date-utils';
import { getBidMultiplierUtils } from './src/bid-multiplier-utils';
import { getInlineDownloadUtils } from './src/inline-download-utils';

export const getHotelCenterUtils = ({ pageContext, i18n, state } = {}) => ({
  ...getBidUtils({ pageContext, i18n }),
  ...getDateUtils({ pageContext }),
  ...getBidMultiplierUtils({ i18n, state }),
  ...getInlineDownloadUtils(),
});
